import { IconProps } from 'assets/Icons/VerifyBadgeIcon';
import React from 'react';

const PlayStoreGetIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={153}
      height={44}
      viewBox='0 0 153 44'
      fill='none'
      {...props}
    >
      <path
        d='M147.359 44H6.33341C3.23225 44 0.692383 41.5236 0.692383 38.5V5.5C0.692383 2.47638 3.23225 2.32537e-06 6.33341 2.32537e-06H147.359C150.46 2.32537e-06 153 2.47638 153 5.5V38.5C153 41.5236 150.46 44 147.359 44Z'
        fill='black'
      />
      <path
        d='M147.359 0.881376C149.971 0.881376 152.096 2.9535 152.096 5.5V38.5C152.096 41.0465 149.971 43.1186 147.359 43.1186H6.33341C3.72161 43.1186 1.59636 41.0465 1.59636 38.5V5.5C1.59636 2.9535 3.72161 0.881376 6.33341 0.881376H147.359ZM147.359 2.32537e-06H6.33341C3.23225 2.32537e-06 0.692383 2.47638 0.692383 5.5V38.5C0.692383 41.5236 3.23225 44 6.33341 44H147.359C150.46 44 153 41.5236 153 38.5V5.5C153 2.47638 150.46 2.32537e-06 147.359 2.32537e-06Z'
        fill='#A6A6A6'
      />
      <path
        d='M12.4651 8.28675C12.1337 8.625 11.9419 9.15162 11.9419 9.83362V34.1601C11.9419 34.8421 12.1337 35.3687 12.4651 35.707L12.5469 35.7812L26.5282 22.155V21.8332L12.5469 8.207L12.4651 8.28675Z'
        fill='url(#paint0_linear_9385_45526)'
      />
      <path
        d='M31.1836 26.7031L26.5283 22.1588V21.837L31.1892 17.2926L31.2936 17.3518L36.8133 20.4139C38.3886 21.2829 38.3886 22.7129 36.8133 23.5874L31.2936 26.644L31.1836 26.7031V26.7031Z'
        fill='url(#paint1_linear_9385_45526)'
      />
      <path
        d='M31.2932 26.6457L26.5279 21.9996L12.4648 35.7125C12.988 36.2487 13.8413 36.3134 14.8115 35.7771L31.2932 26.6457'
        fill='url(#paint2_linear_9385_45526)'
      />
      <path
        d='M31.2932 17.3539L14.8115 8.2225C13.8413 7.69175 12.988 7.75638 12.4648 8.29263L26.5279 22L31.2932 17.3539Z'
        fill='url(#paint3_linear_9385_45526)'
      />
      <path
        d='M54.1892 11.2713C54.1892 12.1898 53.9072 12.9254 53.3516 13.4741C52.7127 14.1244 51.8807 14.4517 50.861 14.4517C49.8866 14.4517 49.0545 14.1189 48.3719 13.4631C47.688 12.7976 47.3467 11.9808 47.3467 11.0032C47.3467 10.0256 47.688 9.20881 48.3719 8.54881C49.0545 7.88744 49.8866 7.55469 50.861 7.55469C51.3462 7.55469 51.8087 7.65231 52.2501 7.83381C52.6901 8.01669 53.0483 8.26419 53.3078 8.56944L52.7183 9.14969C52.2657 8.62856 51.6494 8.37144 50.861 8.37144C50.1503 8.37144 49.534 8.61344 49.0108 9.10156C48.4932 9.59106 48.2337 10.2249 48.2337 11.0032C48.2337 11.7814 48.4932 12.4208 49.0108 12.9103C49.534 13.3929 50.1503 13.6404 50.861 13.6404C51.6155 13.6404 52.2501 13.3929 52.7508 12.9048C53.0808 12.5817 53.2683 12.1362 53.3177 11.5669H50.861V10.7722H54.1385C54.178 10.9441 54.1892 11.1104 54.1892 11.2713V11.2713Z'
        fill='white'
        stroke='white'
        strokeWidth='0.135385'
        strokeMiterlimit={10}
      />
      <path
        d='M59.3886 8.52081H56.31V10.6108H59.0854V11.4056H56.31V13.4956H59.3886V14.3054H55.4385V7.71094H59.3886V8.52081Z'
        fill='white'
        stroke='white'
        strokeWidth='0.135385'
        strokeMiterlimit={10}
      />
      <path
        d='M63.0582 14.3054H62.1867V8.52081H60.2983V7.71094H64.948V8.52081H63.0582V14.3054V14.3054Z'
        fill='white'
        stroke='white'
        strokeWidth='0.135385'
        strokeMiterlimit={10}
      />
      <path
        d='M68.313 14.3054V7.71094H69.1831V14.3054H68.313Z'
        fill='white'
        stroke='white'
        strokeWidth='0.135385'
        strokeMiterlimit={10}
      />
      <path
        d='M73.0401 14.3054H72.1757V8.52081H70.2803V7.71094H74.9355V8.52081H73.0401V14.3054Z'
        fill='white'
        stroke='white'
        strokeWidth='0.135385'
        strokeMiterlimit={10}
      />
      <path
        d='M83.738 13.4521C83.071 14.1189 82.2445 14.4517 81.2588 14.4517C80.2674 14.4517 79.441 14.1189 78.7739 13.4521C78.1083 12.7866 77.7769 11.9698 77.7769 11.0032C77.7769 10.0366 78.1083 9.21981 78.7739 8.55431C79.441 7.88744 80.2674 7.55469 81.2588 7.55469C82.2389 7.55469 83.0653 7.88744 83.7324 8.55981C84.4037 9.23081 84.7351 10.0421 84.7351 11.0032C84.7351 11.9698 84.4037 12.7866 83.738 13.4521ZM79.4184 12.8993C79.9204 13.3929 80.5311 13.6404 81.2588 13.6404C81.9808 13.6404 82.5971 13.3929 83.0935 12.8993C83.5942 12.4057 83.848 11.7718 83.848 11.0032C83.848 10.2346 83.5942 9.60069 83.0935 9.10706C82.5971 8.61344 81.9808 8.36594 81.2588 8.36594C80.5311 8.36594 79.9204 8.61344 79.4184 9.10706C78.9178 9.60069 78.6639 10.2346 78.6639 11.0032C78.6639 11.7718 78.9178 12.4057 79.4184 12.8993V12.8993Z'
        fill='white'
        stroke='white'
        strokeWidth='0.135385'
        strokeMiterlimit={10}
      />
      <path
        d='M85.958 14.3054V7.71094H87.0157L90.3044 12.8397H90.3425L90.3044 11.5719V7.71094H91.1746V14.3054H90.2663L86.8225 8.92369H86.7844L86.8225 10.1969V14.3054H85.958V14.3054Z'
        fill='white'
        stroke='white'
        strokeWidth='0.135385'
        strokeMiterlimit={10}
      />
      <path
        d='M77.5628 23.9269C74.913 23.9269 72.7482 25.8931 72.7482 28.606C72.7482 31.2969 74.913 33.2838 77.5628 33.2838C80.2184 33.2838 82.3831 31.2969 82.3831 28.606C82.3831 25.8931 80.2184 23.9269 77.5628 23.9269ZM77.5628 31.4413C76.1089 31.4413 74.858 30.2711 74.858 28.606C74.858 26.9189 76.1089 25.7694 77.5628 25.7694C79.0168 25.7694 80.2734 26.9189 80.2734 28.606C80.2734 30.2711 79.0168 31.4413 77.5628 31.4413V31.4413ZM67.0578 23.9269C64.4023 23.9269 62.2432 25.8931 62.2432 28.606C62.2432 31.2969 64.4023 33.2838 67.0578 33.2838C69.712 33.2838 71.8725 31.2969 71.8725 28.606C71.8725 25.8931 69.712 23.9269 67.0578 23.9269ZM67.0578 31.4413C65.6025 31.4413 64.3473 30.2711 64.3473 28.606C64.3473 26.9189 65.6025 25.7694 67.0578 25.7694C68.5118 25.7694 69.7627 26.9189 69.7627 28.606C69.7627 30.2711 68.5118 31.4413 67.0578 31.4413ZM54.5573 25.361V27.3493H59.427C59.2845 28.4603 58.9038 29.277 58.3199 29.8463C57.6091 30.5338 56.5021 31.2969 54.5573 31.2969C51.5605 31.2969 49.2139 28.9388 49.2139 26.0169C49.2139 23.095 51.5605 20.7369 54.5573 20.7369C56.1777 20.7369 57.3567 21.3543 58.2268 22.1545L59.6639 20.7534C58.4468 19.6204 56.8279 18.75 54.5573 18.75C50.4479 18.75 46.9941 22.0101 46.9941 26.0169C46.9941 30.0236 50.4479 33.2838 54.5573 33.2838C56.7785 33.2838 58.4468 32.5743 59.7584 31.2433C61.1023 29.9329 61.5212 28.0904 61.5212 26.6026C61.5212 26.1406 61.4817 25.7158 61.4112 25.361H54.5573ZM105.673 26.9024C105.277 25.856 104.055 23.9269 101.564 23.9269C99.096 23.9269 97.0413 25.823 97.0413 28.606C97.0413 31.2268 99.0749 33.2838 101.801 33.2838C104.005 33.2838 105.277 31.9734 105.8 31.2103L104.165 30.1474C103.619 30.9256 102.876 31.4413 101.801 31.4413C100.733 31.4413 99.9676 30.9641 99.4768 30.0236L105.895 27.4345L105.673 26.9024V26.9024ZM99.1299 28.4603C99.0749 26.6563 100.567 25.7323 101.636 25.7323C102.474 25.7323 103.184 26.1406 103.421 26.725L99.1299 28.4603V28.4603ZM93.9134 32.9991H96.0231V19.2491H93.9134V32.9991ZM90.4582 24.9691H90.3877C89.9139 24.4219 89.0099 23.9269 87.8648 23.9269C85.4617 23.9269 83.2645 25.9839 83.2645 28.6211C83.2645 31.2433 85.4617 33.2838 87.8648 33.2838C89.0099 33.2838 89.9139 32.7846 90.3877 32.2209H90.4582V32.8919C90.4582 34.6808 89.4781 35.6419 87.8972 35.6419C86.6082 35.6419 85.8086 34.7344 85.4786 33.9713L83.6439 34.7179C84.1727 35.9581 85.5731 37.4844 87.8972 37.4844C90.3708 37.4844 92.458 36.0654 92.458 32.6128V24.2115H90.4582V24.9691V24.9691ZM88.0453 31.4413C86.5913 31.4413 85.3743 30.2546 85.3743 28.6211C85.3743 26.9725 86.5913 25.7694 88.0453 25.7694C89.4781 25.7694 90.6077 26.9725 90.6077 28.6211C90.6077 30.2546 89.4781 31.4413 88.0453 31.4413V31.4413ZM115.551 19.2491H110.505V32.9991H112.609V27.7893H115.551C117.888 27.7893 120.179 26.1406 120.179 23.5185C120.179 20.8978 117.882 19.2491 115.551 19.2491V19.2491ZM115.606 25.8766H112.609V21.1618H115.606C117.177 21.1618 118.074 22.4336 118.074 23.5185C118.074 24.5828 117.177 25.8766 115.606 25.8766ZM128.613 23.9008C127.092 23.9008 125.512 24.5553 124.861 26.0059L126.729 26.769C127.131 26.0059 127.87 25.7584 128.651 25.7584C129.742 25.7584 130.849 26.3978 130.866 27.5266V27.671C130.486 27.4565 129.67 27.1389 128.668 27.1389C126.657 27.1389 124.608 28.2183 124.608 30.2326C124.608 32.0751 126.255 33.2618 128.106 33.2618C129.522 33.2618 130.304 32.6389 130.794 31.9143H130.866V32.9771H132.898V27.7026C132.898 25.2648 131.031 23.9008 128.613 23.9008ZM128.359 31.4358C127.671 31.4358 126.712 31.103 126.712 30.2711C126.712 29.2069 127.908 28.7985 128.943 28.7985C129.869 28.7985 130.304 28.9979 130.866 29.2605C130.701 30.5338 129.577 31.4358 128.359 31.4358V31.4358ZM140.302 24.2019L137.884 30.1625H137.812L135.311 24.2019H133.042L136.799 32.5316L134.656 37.1668H136.854L142.643 24.2019H140.302V24.2019ZM121.336 32.9991H123.446V19.2491H121.336V32.9991Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_9385_45526'
          x1='25.2868'
          y1='34.4135'
          x2='6.83208'
          y2='15.4855'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00A0FF' />
          <stop offset='0.0066' stopColor='#00A1FF' />
          <stop offset='0.2601' stopColor='#00BEFF' />
          <stop offset='0.5122' stopColor='#00D2FF' />
          <stop offset='0.7604' stopColor='#00DFFF' />
          <stop offset={1} stopColor='#00E3FF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_9385_45526'
          x1='38.8646'
          y1='21.9963'
          x2='11.5655'
          y2='21.9963'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFE000' />
          <stop offset='0.4087' stopColor='#FFBD00' />
          <stop offset='0.7754' stopColor='#FFA500' />
          <stop offset={1} stopColor='#FF9C00' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_9385_45526'
          x1='28.702'
          y1='19.4739'
          x2='3.67586'
          y2='-6.1939'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF3A44' />
          <stop offset={1} stopColor='#C31162' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_9385_45526'
          x1='8.92488'
          y1='43.8062'
          x2='20.1002'
          y2='32.3445'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#32A071' />
          <stop offset='0.0685' stopColor='#2DA771' />
          <stop offset='0.4762' stopColor='#15CF74' />
          <stop offset='0.8009' stopColor='#06E775' />
          <stop offset={1} stopColor='#00F076' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PlayStoreGetIcon;
